import Noty from "noty";
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/relax.css";
import { APP_ENV } from "@/APP_ENV";

export const successfulHandling = (text, afterClose) => {
  new Noty({
    type: "success",
    theme: "relax",
    layout: "topRight",
    closeWith: ["click", "button"],
    timeout: APP_ENV.REACT_APP_NOTY_TIMEOUT || 3000,
    text: text,
    callbacks: {
      afterClose: function () {
        afterClose();
      }
    }
  }).show();
};
